import axios from "../../../../../axios";
import Cookies from "js-cookie";

export const GetAllShortlistCandidates = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetShortlistedCandidate", {
    token,
  });
};